import type { AnnouncementPriority } from './types'

/**
 * Announcement priority palette, aligned with the app's severity convention
 * (src/components/tasks/TaskDetail/primitives.tsx PRIORITY_META: Tailwind color
 * classes + dark variants). Structural colors elsewhere use design tokens
 * (bg-card / text-muted-foreground / border-border / bg-primary).
 *   urgent → red · important → amber · normal → brand primary (indigo/violet).
 */
export const PRIORITY_STYLE: Record<
  AnnouncementPriority,
  { header: string; dot: string; soft: string; accent: string }
> = {
  urgent: {
    header: 'bg-red-600 text-white',
    dot: 'bg-red-600',
    soft: 'bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-300',
    accent: 'text-red-600',
  },
  important: {
    header: 'bg-amber-500 text-white',
    dot: 'bg-amber-500',
    soft: 'bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300',
    accent: 'text-amber-600',
  },
  normal: {
    header: 'bg-primary text-primary-foreground',
    dot: 'bg-primary',
    soft: 'bg-primary/10 text-primary',
    accent: 'text-primary',
  },
}

export function priorityStyle(p: AnnouncementPriority) {
  return PRIORITY_STYLE[p] ?? PRIORITY_STYLE.normal
}
